// extracted by mini-css-extract-plugin
module.exports =  {"selector":"selector-uRGQ6","prev":"prev-__2gh","next":"next-t6hvT","label":"label-xSEWG","icon":"icon-ixEYr","selected":"selected-lBBwk","year":"year-jHuog","month":"month-VlFJ6"};